import { EmbedField, isFilled } from '@prismicio/client'
import styles from './Embed.module.css'

type Props = {
	embed: EmbedField
}

export class Embed {
	static render({ embed }: Props) {
		if (!isFilled.embed(embed)) return ''

		const { width, height, html, provider_name } = embed
		const aspect = Number(width) > 0 && Number(height) > 0 ? `${width} / ${height}` : '16 / 9'

		return /* HTML */ `<div
			class="${styles.Main}"
			style="--aspect: ${aspect};"
			data-oembed-provider="${provider_name ?? ''}"
		>
			${html ?? ''}
		</div>`
	}
}
